import { CONVERTOR_FORM_PAGE_LINK } from "../constants/routingLinks";
import { OPEN_CONVERTOR_FORM } from "../constants/actionTypes";

export const goToConvertorForm = (inputData, history) => async (dispatch) => {
    dispatch({ type: OPEN_CONVERTOR_FORM, payload: inputData});
    history.push(CONVERTOR_FORM_PAGE_LINK);
}